import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        onClose: '&',
        onUpdate: '&'
    },
    template: `
            <div class="modal-header">
                <button type="button" class="close" ng-click="vm.onClose()"></button>
                <h2>{{ 'user.Add requirement set' | translate }}</h2>
            </div>
            <form ng-submit="vm.save()" class="form">
                <div class="modal-body">
                    <div class="form">
                        <form-row ng-if="vm.form.errors.drls" error="vm.form.errors.drls">
                        <div class="items"><form-row-error></form-row-error></div>
                        </form-row>
                        <form-row error="vm.form.errors.departmentId">
                            <label class="label">{{ 'user.Department' | translate }}</label>
                            <div class="items">
                                <form-row-error></form-row-error>
                                <ui-select ng-model="vm.department" theme="selectize" title="{{ 'user.Choose department' | translate }}">
                                    <ui-select-match placeholder="{{ 'user.Select or search a department in the list...' | translate }}">{{$select.selected.value}}</ui-select-match>
                                    <ui-select-choices repeat="department in vm.departments | filter: $select.search">
                                        <span ng-bind-html="department.value | highlight: $select.search" class="{{department.class}}"></span>
                                    </ui-select-choices>
                                </ui-select>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.roleId">
                            <label class="label">{{ 'user.Role' | translate }}</label>
                            <div class="items">
                                <form-row-error></form-row-error>
                                <ui-select ng-model="vm.role" theme="selectize" title="{{ 'user.Choose role' | translate }}">
                                    <ui-select-match placeholder="{{ 'user.Select or search a role in the list...' | translate }}">{{$select.selected.value}}</ui-select-match>
                                    <ui-select-choices repeat="role in vm.roles | filter: $select.search">
                                        <span ng-bind-html="role.value | highlight: $select.search" class="{{role.class}}"></span>
                                    </ui-select-choices>
                                </ui-select>
                            </div>
                        </form-row>
                        <form-row error="vm.form.errors.levelId">
                            <label class="label">{{ 'user.Level' | translate }}</label>
                            <div class="items">
                                <form-row-error></form-row-error>
                                <ui-select ng-model="vm.level" theme="selectize" title="{{ 'user.Choose level' | translate }}">
                                    <ui-select-match placeholder="{{ 'user.Select or search a level in the list...' | translate }}">{{$select.selected.value}}</ui-select-match>
                                    <ui-select-choices repeat="level in vm.levels | filter: $select.search">
                                        <span ng-bind-html="level.value | highlight: $select.search" class="{{level.class}}"></span>
                                    </ui-select-choices>
                                </ui-select>
                            </div>
                        </form-row>
                    </div>
                </div>
                <div class="modal-footer">
                    <ul class="actions01">
                        <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button></li>
                        <li><button class="btn discrete" type="button" ng-click="vm.onClose()">{{ 'general.Cancel' | translate }}</button></li>
                    </ul>
                </div>
            </form>
    `
})
export default class {
    constructor (FormFactory, CompetenceRequirementResource, ClassifierResource, CLASSIFIER_ENUM) {
        this.FormFactory = FormFactory;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ClassifierResource = ClassifierResource;
        this.CompetenceRequirementResource = CompetenceRequirementResource;
    }

    $onInit () {
        this.form = this.FormFactory.createFromResource(new this.CompetenceRequirementResource());
        this.ClassifierResource.query({ pageSize: 0 }).$promise.then(results => {
            this.departments = results.filter(classifier => classifier.type === this.CLASSIFIER_ENUM.KEYS.DEPARTMENT);
            this.roles = results.filter(classifier => classifier.type === this.CLASSIFIER_ENUM.KEYS.ROLE);
            this.levels = results.filter(classifier => classifier.type === this.CLASSIFIER_ENUM.KEYS.LEVEL);
        });
    }

    save () {
        if (this.department) {
            this.form.model.departmentId = this.department.id;
        }
        if (this.role) {
            this.form.model.roleId = this.role.id;
        }
        if (this.level) {
            this.form.model.levelId = this.level.id;
        }
        return this.form.save().then(() => {
            return this.onUpdate();
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/requirements/add/index.js